/* eslint-disable react-native/no-color-literals */
/* eslint-disable react/jsx-no-bind */
/* eslint-disable react-native/no-inline-styles */
/* eslint-disable max-len */
import Spinner from '@atlaskit/spinner';
import React, { FC, useCallback, useState } from 'react';
import { useSelector } from 'react-redux';

import { useSocket } from '../../../../../../socket/socket.context';
import { Icon, IconAddCircle, IconRemove } from '../../../../base/icons';
import AddExistedContactsModal from '../AddExistedContactsModal';
import { ModalSelectGroupCall } from '../ModalSelectGroupCall';


type EditGroupProps = {
    onClose: () => any;
    open?: boolean;
    group: any;
};

export const EditGroup: FC<EditGroupProps> = props => {
    const { open, onClose, group, selectedUserList } = props;
    const { user } = useSelector(state => state['features/settings']);
    const [ groupState, setGroupState ] = useState(group || {});
    const [ loading, setLoading ] = useState(false);
    const [ errors, setErrors ] = useState({});
    const [ openConfirm, setOpenConfirm ] = useState(false);
    const [ openConfirmDelete, setOpenConfirmDelete ] = useState(false);
    const [ openSelectContact, setOpenSelectContact ] = useState(false);
    const socketContext = useSocket();

    const handleChangeName = useCallback(event => {
        setGroupState(pre => {
            return { ...pre,
                name: event.target.value };
        });
    }, []);

    const onRemoveContact = useCallback(contact => {
        setGroupState(pre => {
            return { ...pre,
                contacts: pre.contacts.filter(item => item.id !== contact.id) };
        });
    }, []);

    const handleSubmitAddExistedContacts = useCallback(contacts => {
        const list = contacts.filter(item => item.isContact);

        setGroupState(pre => {
            return { ...pre,
                contacts: [ ...pre.contacts, ...list ] };
        });
    }, []);


    const handleSave = () => {
        const newErrors = {};

        if (groupState.name?.length > 30) {
            newErrors.groupName = 'Maximum length is 30 characters !';
        }
        if (!groupState.name?.trim()) {
            newErrors.groupName = 'Please add the group name!';
        }
        if (!groupState.contacts?.length) {
            newErrors.members = 'Please add the group member!';
        }
        setErrors(newErrors);

        if (Object.keys(newErrors).find(key => newErrors[key])) {
            return;
        }
        setOpenConfirm(true);
    };

    const handleSubmit = () => {
        setLoading(true);
        try {
            if (openConfirmDelete) {
                socketContext.removeGroup(groupState, user);
            } else {
                socketContext.editGroup({ ...groupState,
                    contactIds: groupState.contacts.map(c => c._id) }, user);
            }
        } catch (e) {
            console.log(e);
        } finally {
            onClose();
            setLoading(false);
            setOpenConfirm(false);
        }
    };

    const renderItems = () => groupState?.contacts?.map((item, index) => (
        <div
            className = { 'o-create-group-content-label-list' }
            key = { index }>
            <p>{item.name} {item.lastName || item.subName}</p>
            <div
                className = { 'o-create-group-content-label-list--remove' }
                onClick = { () => onRemoveContact(item) }>
                <Icon
                    color = '#000000'
                    size = { 20 }
                    src = { IconRemove } />
            </div>
        </div>
    ));

    return (
        <>
            <ModalSelectGroupCall
                onClose = { onClose }
                open = { open }
                style = {{
                    transition: 'all 0.3s',
                    opacity: Number(!(openConfirm || openConfirmDelete || openSelectContact))
                }}
                width = { 360 }>
                <div className = 'o-create-group-title'>
                    <p>Edit Group</p>
                </div>
                <div className = { 'o-create-group-content' }>
                    <div
                        className = { 'o-create-group-content-add-label-input' }
                        style = {{ margin: 0 }}>
                        <input
                            className = { 'o-create-group-content-add-label-input--child o-add-contact-popup--inputs--input' }
                            onChange = { handleChangeName }

                            placeholder = { 'Add Label' }
                            style = {{ marginTop: 0 }}
                            value = { groupState.name } />
                    </div>
                    { errors.groupName ? <p className = { 'o-create-group-content-error-message ' }>{errors.groupName}</p> : null }
                    <div
                        className = { 'o-create-group-content--list-items' }
                        style = {{ margin: '10px 0' }}>
                        {renderItems()}
                    </div>
                    <div
                        className = { 'o-create-group-content-add-label' }
                        onClick = { () => setOpenSelectContact(true) }
                        style = {{ margin: '10px 0' }}>
                        <p>Add Contact</p>
                        <div
                            className = { 'o-create-group-content-add-label--add' }>
                            <Icon

                                size = { 30 }
                                src = { IconAddCircle } />
                        </div>
                    </div>
                    { errors.members ? <p className = { 'o-create-group-content-error-message ' }>{errors.members}</p> : null }
                </div>
                <div
                    className = { 'o-add-contact-popup--buttons' }
                    style = {{ marginTop: 20 }}>
                    <div
                        className = { 'o-add-contact-popup--delete' }
                        onClick = { () => setOpenConfirmDelete(true) }>
                        Delete
                    </div>
                    <div
                        className = { 'o-add-contact-popup--cancel' }
                        onClick = { onClose }>Cancel</div>
                    <div
                        className = { 'o-add-contact-popup--save' }
                        onClick = { handleSave }>
                        Save
                    </div>
                </div>
            </ModalSelectGroupCall>
            <ModalSelectGroupCall
                open = { openSelectContact }
                width = { 400 }>
                <AddExistedContactsModal
                    addContactList = { groupState.contacts || [] }
                    handleSubmitAddExistedContacts = { handleSubmitAddExistedContacts }
                    onClose = { () => setOpenSelectContact(false) }
                    selectedUserList = { selectedUserList } />
            </ModalSelectGroupCall>
            <ModalSelectGroupCall
                closeable = { false }
                open = { openConfirm || openConfirmDelete }>
                <div
                    style = {{
                        color: '#000000',
                        fontSize: 20
                    }}>
                    {openConfirm ? 'Are you sure you want to update this group?' : 'Are you sure you want to delete this group?'}
                </div>
                <div
                    className = { 'o-add-contact-popup--buttons mt-15' }
                    style = {{ justifyContent: 'center' }}>
                    <div
                        className = { 'o-add-contact-popup--cancel' }
                        onClick = { () => {
                            setOpenConfirm(false);
                            setOpenConfirmDelete(false);
                        } }>
                        Cancel
                    </div>
                    <div
                        className = { 'o-add-contact-popup--save ml-10' }
                        onClick = { handleSubmit }>
                        {loading ? <Spinner /> : 'Continue'}
                    </div>
                </div>
            </ModalSelectGroupCall>
        </>
    );

};
